// extracted by mini-css-extract-plugin
export var bodyRow = "_fx-d";
export var cardColumns = "_fx-e";
export var ellipsesOverflow = "_fx-2";
export var flatBottomCorners = "_fx-3";
export var flatTopCorners = "_fx-4";
export var headerActionsDropdown = "_fx-f";
export var headerBottomRow = "_fx-c";
export var headerTopRow = "_fx-b";
export var orderDetailsWrapper = "_fx-0";
export var orderInfoContainer = "_fx-1";
export var productDetails = "_fx-9";
export var productImage = "_fx-5";
export var responsiveTable = "_fx-8";
export var shipmentContainer = "_fx-a";
export var tableBottomLeft = "_fx-6";
export var tableBottomRight = "_fx-7";